import NavBar from './nav_bar_container';

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/index.jsx